import classnames from "classnames";
import React, { Component } from "react";
import _ from "underscore";
import ReactDOM from "react-dom";
import {
  processEditRegionSequence,
  handleValidationErrors,
} from "../../../../util/format";
import {
  LeftThumb,
  RightThumb,
} from "../../../Common/Misc/TextSelector/Thumb.jsx";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "../../AssayCreate.scss";

/**
 * ConfirmSubmissionHeader
 * - Header for the composite component `ConfirmSubmissionPlacard`
 * @param {[object]} classes
 * - [style object is passed from owner to tenant component to avoid too much wrapping ]
 * @superComponent <ConfirmSubmissionPlacard/>
 */
export const ConfirmSubmissionHeader = (classes) => {
  return (
    <h1 className={classnames(classes.targetApp)} id="GenomeEditDetection">
      Genome Edit Detection{" "}
      <span className={classnames(classes.sub_header)}>
        – Confirm Submission
      </span>{" "}
    </h1>
  );
};

/**
 * ConfirmSubmissionSchematic
 *  - Placard for displaying the gene sequences
 * @param {[object]} props [Style object and Children Component for the component]
 * @superComponent <ConfirmSubmissionPlacard/>
 */
export class ConfirmSubmissionSchematic extends Component {
  render() {
    const { classes, children } = this.props;
    return (
      <div
        id="confirm-submission-schematic"
        className={classnames(
          "placard",
          classes.schematic,
          classes.selection_container,
          "d-flex",
          "justify-content-center"
        )}
      >
        <div
          ref={this.handleDivRef}
          className={classnames(
            "row",
            classes.selection_area,
            "placard",
            "d-inline-flex",
            "justify-content-center"
          )}
        >
          {children}
        </div>
      </div>
    );
  }
}

/**
 * HorizontalBar
 * - Horizontal seperator
 * - Generic Component
 * @param {[object]} classes [Style object from the parent]
 * EDIT: Move it to helper compoenents in next refactor.
 *
 */
export const HorizontalBar = (classes) => (
  <hr className={classnames(classes.hrBar)} />
);

/**
 * ConfirmSubmissionDescription
 * - Helper text for the GeneEditDetection Confirmation process
 * @param {[object]} classes [Style object for the component]
 * @superComponent <ConfirmSubmissionPlacard/>
 */
export const ConfirmSubmissionDescription = (classes) => (
  <div className="row">
    <div className="col-sm-12">
      <div className={classnames(classes.description)}>
        A schematic of your donor representing the left homology arm, right
        homology arm, and edit region is shown below. A probe will be placed in
        the edit region, covering one or more of the edits shown. Bases in the
        homology arms that differ from the wild-type sequence are shown in red.
        Primers will not placed over these bases.
      </div>
      <br />
    </div>
  </div>
);

/**
 * ConfirmSubmissionDescription
 * - Helper text for the GeneEditDetection Confirmation process
 * @param {[object]} classes [Style object for the component]
 * @superComponent <ConfirmSubmissionPlacard/>
 */
export const ConfirmSubmissionSubHeader = (classes) => (
  <div className="row">
    <div className="col-sm-12">
      <div className={classnames(classes.diagram_header)}>
        Diagram of Donor
        <OverlayTrigger
          trigger="hover"
          placement="auto"
          overlay={
            <Popover title="Diagram of Donor">
              To change the edit region, select <b>Modify</b>. Reposition the
              slider bar to speciify the desired edit region and select{" "}
              <b>Update Diagram of Donor</b>. Verify edits and click{" "}
              <b>Confirm</b> to proceed.
            </Popover>
          }
        >
          <i className="far fa-question-circle helper-icon" />
        </OverlayTrigger>
      </div>
      <br />
    </div>
  </div>
);

/**
 * GeneEditSequenceSpanElement
 * Component Hosting the Each Letter in the Sequence
 * - Helper component to make it draggable and maintain state
 * @param {[object]} classes [Style object for the the component]
 * @superComponent GeneEditSequenceDisplay
 */

export class GeneEditSequenceSpanElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlighted: false,
      dimensions: {},
    };
  }

  render() {
    const { selected, gene, index, geneElement } = this.props;
    return (
      <span className={classnames(selected, geneElement)} key={index}>
        {gene}
      </span>
    );
  }
}

/**
 *
 * @param Sequence
 * @returns {ConfirmSubmissionDiagram } component will be returned
 *
 */

const DiagramLabel = ({ text, classes }) => (
  <label className={classnames("homology-label", "row", classes.label)}>
    {text}
  </label>
);

const DiagramSubHeader = ({ text, classes }) => (
  <label className={classnames("homology-label", "row", classes.label)}>
    {text}
  </label>
);

const DiagramTable = ({ classes, genesToBeDisplayed }) => (
  <table className={classes.label_table}>
    <tbody>
      {genesToBeDisplayed.map((value, index) => (
        <React.Fragment key={index}>
          <tr className={classes.row}>
            <td
              className={classnames(
                classes.data,
                classes.row,
                classes.edits,
                classes.primary_header
              )}
            >
              EDITS
            </td>
            <td
              className={classnames(classes.data, classes.row, classes.edits)}
            >
              {value.edited}
            </td>
          </tr>

          <tr className={classes.row}>
            <td
              className={classnames(
                classes.data,
                classes.row,
                classes.primary_header
              )}
            >
              NATIVE
            </td>
            <td className={classnames(classes.data, classes.row)}>
              {value.native}
            </td>
          </tr>

          <tr className={classes.row}>
            <td className={classes.data}></td>
            <td className={classes.data_star}>{value.match}</td>
          </tr>
        </React.Fragment>
      ))}
    </tbody>
  </table>
);

export const ConfirmSubmissionDiagram = ({
  classes,
  editRegionSequence,
  rightHomologyArmSequence,
  leftHomologyArmSequence,
}) => (
  <div className={classnames("container", "placard", classes.schematic)}>
    <div className="container-fluid row col-sm-12">
      <DiagramLabel classes={classes} text="Left Homology Arm" />
      <div className={classnames("data-homology-sequence")}>
        <div className={classnames(classes.homology)}>
          <p className={classes.diagram_para}>
            <span className={classes.span_element}>
              {leftHomologyArmSequence}
            </span>
          </p>
        </div>
      </div>
    </div>

    <div>
      <DiagramLabel classes={classes} text="Primary Edits" />

      <DiagramTable
        classes={classes}
        genesToBeDisplayed={processEditRegionSequence(editRegionSequence)}
      />
    </div>

    <div className="container-fluid row col-sm-12">
      <DiagramLabel classes={classes} text="Right Homology Arm" />
      <div className={classnames("data-homology-sequence")}>
        <div className={classnames(classes.homology)}>
          <p className={classes.diagram_para}>
            <span className={classes.span_element}>
              {rightHomologyArmSequence}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export const ValidationErrorComponent = (validationErrors) => (
  <div className="fail-message">
    {_.map(validationErrors, (error, index) => (
      <span key={index}>
        {handleValidationErrors(error.Code) || error.Text}
      </span>
    ))}
  </div>
);
